module.exports = __webpack_public_path__ + "static/media/unit-page.42b7357f.jpeg";